import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';
import { detectedPaychecksAtom } from '../../state/PaycheckRoutingAtoms';
import type { PaycheckRoutingIncomeDetail } from '../../types/PaycheckRouting';

const useGetPaychecks = requestBuilder.query<PaycheckRoutingIncomeDetail[]>({
    endpoint: () => `/api/paychecks`,
    queryKey: () => `getPaychecks`,
});

const useGetAllPaychecks = () => {
    const setAllPaychecks = useSetAtom(detectedPaychecksAtom);

    const { data: detectedPaychecks, isLoading } = useGetPaychecks({});

    useEffect(() => {
        setAllPaychecks(detectedPaychecks ?? []);
    }, [detectedPaychecks]);

    return {
        detectedPaychecks,
        isLoading,
    };
};

export default useGetAllPaychecks;
